<template>
    <div>
         <!-- modal -->
    <b-modal id="lawCounterPartyFormModal" centered size="lg" no-close-on-backdrop ref="lawCounterPartyFormModal" :title=" $t('lawCounterParty.info')" :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate">
        <validation-observer ref="simpleRules">
            <b-row>
                 <b-col class="col-lg-6">
                <b-form>
                <label for="law-counter-party-name-input">{{ $t('lawCounterParty.type') }}</label>
                     <b-form-group>
                             <validation-provider #default="{ errors }" :name=" $t('lawCounterParty.type')" rules="required">
                              <b-form-input id="law-counter-party-name-input" v-model="name" size="sm" maxlength="50" :state="errors.length > 0 ? false:null" />
                              <small class="text-danger">{{ errors[0] }}</small>
                              </validation-provider>
                     </b-form-group>
                  </b-form>
                 </b-col>
                 <b-col class="col-lg-3">
                    <b-form>
                         <label for="law-counter-party-country-input">{{ $t('lawCounterParty.country') }}</label>
                         <b-form-group>
                                    <b-form-select  id="law-counter-party-country-input" size="sm" v-model="countrySelect" value-field="id" text-field="name" :options="countryOptions" @change="showCity(countrySelect)"/>
                        </b-form-group>
                    </b-form>
                 </b-col>
                  <b-col class="col-lg-3">
                    <b-form>
                         <label for="law-counter-party-city-input">{{ $t('lawCounterParty.city') }}</label>
                         <b-form-group>
                                    <b-form-select :disabled = "!isCityVisible"  id="law-counter-party-city-input" size="sm" v-model="citySelect" value-field="id" text-field="name" :options="cityOptions"/>
                        </b-form-group>
                    </b-form>
                 </b-col>
            </b-row>
            <b-row>
                <b-col class="col-md-6">
                   <b-form>
                    <label for="law-counter-party-address-input">{{ $t('lawCounterParty.address') }}</label>
                     <b-form-group>
                         <b-form-input id="law-counter-party-address-input" v-model="address" size="sm" maxlength="250" />
                     </b-form-group>
                    </b-form>
                </b-col>
                 <b-col class="col-md-6">
                <b-form>
                <label for="law-counter-party-sub-type-name-input">{{ $t('lawCounterParty.law_counter_party_sub_type_name') }}</label>
                     <b-form-group>
                             <validation-provider  v-slot="{ errors }" :name="$t('lawCounterParty.law_counter_party_sub_type_name')" :rules="{ excluded:0}">
                              <b-form-select  id="law-counter-party-sub-type-name-input" size="sm" v-model="lawCounterPartySubTypeSelect" value-field="id" text-field="name" :options="lawCounterPartySubTypeOptions" :state="errors.length > 0 ? false:null" />
                              <small class="text-danger">{{ errors[0] }}</small>
                              </validation-provider>
                     </b-form-group>
                  </b-form>
                 </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-4">
                   <b-form>
                    <label>{{ $t('lawCounterParty.identification_number') }}</label>
                     <b-form-group>
                         <b-form-input  v-model="identificationNumber" size="sm" maxlength="50" />
                     </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-4">
                   <b-form>
                    <label>{{ $t('lawCounterParty.email') }}</label>
                     <b-form-group>
                         <b-form-input  v-model="email" size="sm" maxlength="50" />
                     </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-4">
                   <b-form>
                    <label>{{ $t('lawCounterParty.telephone') }}</label>
                     <b-form-group>
                         <b-form-input  v-model="telephone" size="sm" maxlength="50" />
                     </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-4">
                   <b-form>
                    <label>{{ $t('lawCounterParty.authorized_person') }}</label>
                     <b-form-group>
                         <b-form-input v-model="authorizedPerson" size="sm" maxlength="50" />
                     </b-form-group>
                    </b-form>
                </b-col>
                 <b-col class="col-lg-4">
                   <b-form>
                    <label>{{ $t('lawCounterParty.title') }}</label>
                     <b-form-group>
                         <b-form-input v-model="title" size="sm" maxlength="50" />
                     </b-form-group>
                    </b-form>
                </b-col>
                 <b-col class="col-lg-4">
                   <b-form>
                    <label>{{ $t('lawCounterParty.organization') }}</label>
                     <b-form-group>
                         <b-form-input v-model="organization" size="sm" maxlength="50" />
                     </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
              <b-row>
                   <b-col class="col-lg-12">
                        <label for="law-counter-party-note-input">{{ $t('lawCounterParty.note') }}</label>
                        <b-form-textarea id="law-counter-party-note-input" :placeholder=" $t('lawCounterParty.note')" rows="3" v-model="note" maxlength="250" />
                    </b-col>
            </b-row>
        </validation-observer>
    </b-modal>
    </div>
</template>

<script>
export default {
    props: {
        getLawCounterPartyList: {
            type: Function
        }
    },
    data() {
        return {
            id: 0,
            name: '',
            countryOptions: [],
            countrySelect: 0,
            cityOptions: [],
            citySelect: 0,
            address: '',
            note: '',
            lawCounterPartySubTypeOptions: [],
            lawCounterPartySubTypeSelect: 0,
            identificationNumber: '',
            email: '',
            telephone: '',
            authorizedPerson: '',
            title: '',
            organization: '',
            isCityVisible : false

            
        }
    },
    methods: {
        async showInfo(id) {
            this.$refs['lawCounterPartyFormModal'].show()
            this.id = id
            const data = {   id: this.id  }
            const controller = {  name: 'LawCounterParty' }
            const payload = { data: data,controller: controller}
                
            const response = await this.$store.dispatch('moduleAuth/getInfo', payload)
                if (response.data.resultStatus == true) {
                    this.name = response.data.lawCounterParty.name
                    this.address = response.data.lawCounterParty.address
                    this.note = response.data.lawCounterParty.note
                    this.countryOptions = response.data.countryList
                    this.countryOptions.splice(0, 0, this.$nullSelected())
                    this.countrySelect = response.data.lawCounterParty.countryId
                    if(this.countrySelect == 120){
                        this.isCityVisible = true
                    }
                    this.cityOptions = response.data.cityList
                    this.cityOptions.splice(0, 0, this.$nullSelected())
                    this.citySelect = response.data.lawCounterParty.cityId
                   
                    this.lawCounterPartySubTypeOptions = response.data.lawCounterPartySubTypeList
                    this.lawCounterPartySubTypeOptions.splice(0, 0, this.$nullSelected())
                    this.lawCounterPartySubTypeSelect = response.data.lawCounterParty.lawCounterPartySubTypeId

                    this.identificationNumber = response.data.lawCounterParty.identificationNumber
                    this.email = response.data.lawCounterParty.email
                    this.telephone = response.data.lawCounterParty.telephone
                    this.authorizedPerson =response.data.lawCounterParty.authorizedPerson
                    this.title = response.data.lawCounterParty.title
                    this.organization = response.data.lawCounterParty.organization
                } else {
                    this.$bvModal.hide('lawCounterPartyFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
           
        },
        async addOrUpdate() {
            const data = {
                id: this.id,
                name: this.name,
                address: this.address,
                note: this.note,
                countryId: this.countrySelect,
                cityId: this.citySelect,
                lawCounterPartySubTypeId: this.lawCounterPartySubTypeSelect,
                identificationNumber: this.identificationNumber,
                email: this.email,
                telephone: this.telephone,
                authorizedPerson: this.authorizedPerson,
                title: this.title,
                organization: this.organization
            }
            const controller = {  name: 'LawCounterParty' }
            const payload = {    data: data,controller: controller}
            
            const success = await this.$refs.simpleRules.validate()
                if (success) {
                    const response = await this.$store.dispatch('moduleAuth/save', payload)
                        if (response.data.resultStatus == true) {
                            this.$bvModal.hide('lawCounterPartyFormModal')
                            this.getLawCounterPartyList()
                            this.$SaveAlert()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                }
        },
        showCity(countryId){
            this.isCityVisible = (countryId === 120);
        }
    }
}
</script>
  
<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
</style>
